import {Subscription} from 'rxjs';

// tslint:disable-next-line:max-line-length
import createPlaybackInterruptedConnectionLostStream from '../Shared/Streams/createPlaybackInterruptedConnectionLostStream';
import createPlaybackStatusStream from '../Shared/Streams/createPlaybackStatusStream';

import IPlayer                   from './Interfaces/IPlayer';
import subscribeToConsumerError  from './Subscriptions/subscribeToConsumerError';
import subscribeToPlaybackInterruptedConnectionLost from './Subscriptions/subscribeToPlaybackInterruptedConnectionLost';
import subscribeToPlaybackStatus from './Subscriptions/subscribeToPlaybackStatus';

const connectPlayerSubscriptions = (player: IPlayer): Subscription[] => [
    subscribeToConsumerError(player.errors$, player),
    subscribeToPlaybackStatus(createPlaybackStatusStream(player.state.stores.playback.update$), player),
    subscribeToPlaybackInterruptedConnectionLost(
        createPlaybackInterruptedConnectionLostStream(player.state.stores.playback.update$),
        player.consumerOutput.errors$
    )
];

export default connectPlayerSubscriptions;